import React from 'react';
import { Link } from 'react-router-dom';
import { HomeSectionShell } from './HomeSectionShell';
import {
  AFFILIATE_MEMBERSHIP,
  MEMBERSHIP_COMPARE_SECTION,
  MEMBERSHIP_DEMO_URL,
  MEMBERSHIP_SIGNUP_URL,
  PUBLIC_ACCESS_ITEMS,
  REGULAR_MEMBERSHIP,
} from './homePageConstants';

export const PublicVsMembershipSection: React.FC = () => (
  <HomeSectionShell
    id="public-vs-membership"
    title={MEMBERSHIP_COMPARE_SECTION.title}
    subtitle={MEMBERSHIP_COMPARE_SECTION.subtitle}
    variant="muted"
  >
    <div className="home-compare home-compare--three">
      <article className="home-compare__column home-compare__column--public">
        <h3 className="home-compare__heading">Public Access</h3>
        <ul className="home-compare__list">
          {PUBLIC_ACCESS_ITEMS.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </article>

      <article className="home-compare__column home-compare__column--affiliate">
        <h3 className="home-compare__heading">{AFFILIATE_MEMBERSHIP.title}</h3>
        <p className="home-compare__price">{AFFILIATE_MEMBERSHIP.priceLabel}</p>
        <p className="home-compare__label">Benefits:</p>
        <ul className="home-compare__list">
          {AFFILIATE_MEMBERSHIP.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </article>

      <article className="home-compare__column home-compare__column--regular">
        <h3 className="home-compare__heading">{REGULAR_MEMBERSHIP.title}</h3>
        <p className="home-compare__price">{REGULAR_MEMBERSHIP.priceLabel}</p>
        <p className="home-compare__label">{REGULAR_MEMBERSHIP.includesNote}</p>
        <ul className="home-compare__list">
          {REGULAR_MEMBERSHIP.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </article>
    </div>

    <div className="home-compare__actions">
      <Link to={MEMBERSHIP_SIGNUP_URL} className="home-btn home-btn--primary">
        Become a Member
      </Link>
      <Link to={MEMBERSHIP_DEMO_URL} className="home-btn home-btn--secondary">
        Schedule a Demo
      </Link>
    </div>
  </HomeSectionShell>
);
